// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { recentWishListsStyles } from "@vanmeter/Overrides/Widgets/Common/RecentWishLists";
import { constants } from "@vanmeter/XDL/constants";
import { color, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

recentWishListsStyles.cardContainer = {
    gridItem: {
        width: 12,
        css: css`
            padding: 12px 0;
        `,
    },
    cardDivider: {
        css: css`
            width: 100%;
            margin: 0;
            border-bottom: 1px solid ${color("common.ui3")};
        `,
    },
};

recentWishListsStyles.cardListStyles = {
    gridContainer: {
        gap: 0,
    },
};

recentWishListsStyles.notify = {
    css: css`
        margin-top: 12px;
    `,
};

recentWishListsStyles.wishListCard = {
    gridContainer: {
        css: css`
            grid-template-columns: minmax(0, 300px) 300px minmax(100px, 1fr) 200px;
            ${xScreen("lte", constants.Dashboard.breakpoints.md)} {
                grid-template-columns: minmax(317px, 1fr) minmax(0, 1fr);
            }
            ${xScreen("lte", "sm")} {
                grid-template-columns: 1fr;
            }
        `,
    },
};
